import React from 'react'
import {Box, Divider, Grid, LinearProgress, Paper, Tooltip, Typography} from '@mui/material'
import { darkGrey, headingBlue, lightGrey, mediumGrey } from '../../assets/colors'

const StatsBarCard = ({Icon, data, label, color, selectedTile, updateTile}) => {
  return (
    <>
      <Paper elevation={0} sx={{ backgroundColor: '#f3f3f3', p: '0.4rem 0.3rem 0rem 0.3rem',
        border: (selectedTile && selectedTile === data?._id) ? `1px solid ${color}` : `0px solid`
      }}
        onClick={() => updateTile(data?._id)}
      
      >
        <Box style={{minWidth: 0, width: '90%',  display: "flex", alignItems: "flex-end", justifyContent: 'center'}}>
          <Box style={{width: '100%',padding: '0rem 0.3rem 0rem 0.3rem', display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}>
            <Typography style={{lineHeight: 1, color: color, fontSize: '2rem'}}>
              {data?.count || 0}
            </Typography>
            {/* <Typography sx={{lineHeight: 2, color: color, fontSize: { xs: "0.75rem",sm: "0.85rem",md: "0.95rem",
                p: '0rem 0rem 1rem 0rem',
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"  }}}>
              {label || '-'}
            </Typography> */}
            
          </Box>
          {/* {Icon && <Icon sx={{color: color, fontSize: { xs: "1rem",sm: "1.25rem",md: "1.5rem"  }, p: '0rem 0rem 0.4rem 0rem'}}></Icon>} */}
          
        </Box>
        <Box style={{width: '95%', padding: '0.2rem 0.25rem 0rem 0rem'}}>
          <Tooltip title={`${data?.percentage || 0} %`}>
            <LinearProgress
              variant='determinate'
              value={data?.percentage || 0}
              sx={{
                width: '100%',
                height: 8,
                borderRadius: 5,
                backgroundColor: mediumGrey,
                "& .MuiLinearProgress-bar": {
                  backgroundColor: color,
                }
              }}
            >
            </LinearProgress>
          </Tooltip>
        </Box>
        <Box style={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography sx={{lineHeight: 2, color: color, fontSize: { xs: "0.75rem",sm: "0.85rem",md: "0.95rem",
                p: '0rem 0rem 1rem 0rem',
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"  }}}>
              {label || '-'}
            </Typography>
        </Box>
      </Paper>
    </>
  )
}

export default StatsBarCard
